import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, NgForm, Validators } from '@angular/forms';
import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/_core/auth.service';
import { EntityService } from 'src/app/_core/entity.service';

@Component({
    selector: 'app-login-dialog',
    templateUrl: './login-dialog.component.html',
    styleUrls: ['./login-dialog.component.scss'],
    standalone: false
})
export class LoginDialogComponent {
	formModel: any = {};
	errorMessage: string = null;
	savePaymentInfo: boolean;
	hide: Boolean = true;
	loyaltySignInResponse: any;
	title: string;
	step: number = 0;
	enableAnonymousLogin;

	stepsMap = {
		'sign': 0,
		'register': 1,
		'confirm': 2,
	}
	ui: any = {}

	public signFormGroup;

	constructor(
		public appService: AppService,
		public authService: AuthService,
		public entityService: EntityService,
		public dialogRef: MatDialogRef<LoginDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {

		this.enableAnonymousLogin = (this.data.from == 'tabitOrder' || this.data.from == 'tabOrder');

		let _cacheContact = this.appService.cacheContact || {}
		let _name: any = this.data.name || _cacheContact.name;
		if (_name) {
			_name = _name.split(" ");
			this.formModel.FirstName = _name[0];
			this.formModel.LastName = _name[1];
		}
		let phone = this.data.phone || localStorage.getItem('c_phone') || _cacheContact.phone;
		this.formModel.phone = phone;

		this.signFormGroup = new UntypedFormGroup({
			phone: new UntypedFormControl(phone || '', [Validators.required]),
			savePaymentInfo: new UntypedFormControl('', []),
		});


		if (this.appService.cachedPaymentInfo) this.savePaymentInfo = true;
		this.getTitle();

		switch (this.data.from) {
			case "tabitOrder":
				this.ui = {...this.ui, ...{
					licenseCaption: '_LOYALTY.sprompt_license_tabitorder'
				}}
				break;
		}

	}

	cancel() {
		this.dialogRef.close();
	}

	onModelChange(changes?) {
		this.errorMessage = null;
	}

	getTitle() {
		switch (this.step) {
			case this.stepsMap.register:
				this.title = this.appService.translate('_LOYALTY.register_title');
				break;
			case this.stepsMap.confirm:
				this.title = this.appService.translate('_LOYALTY.confirm_title');
				break;

			default:
				this.title = this.appService.translate('_LOYALTY.sign_title');
				break;
		}
	}

	//------------------------------------------------------------------------------------------------->
	// signIn
	//------------------------------------------------------------------------------------------------->

	signIn(form) {
		if (!this.signFormGroup.valid) {
			this.signFormGroup.get("phone").markAsTouched({ onlySelf: true });
			return;
		}
		let formModel = this.formModel = { ...this.formModel, ...this.signFormGroup.value };
		localStorage.setItem('c_phone', formModel.phone);

		this.ui.loading = true;
		this.appService.trackData('sign in continue')
		this.authService.signInByPhone$(formModel).subscribe(
			(response: any) => {
				this.appService.logTemplate("signIn", { request: formModel, response: response }, `sign in: ${_.get(response, 'ResponseData.LoginResult', 'unknown')}`);
				this.ui.loading = false;
				if (response && response.IsSuccess && response.ResponseData) {

					// We need to "remember" this so that we'll know to show the First and Last name form (step 5) so the user can update his/her details
					this.loyaltySignInResponse = response.ResponseData.LoginResult;

					if (response.ResponseData.LoginResult == 'NewCustomer') {
						// Redirecting to registration form
						this.step = this.stepsMap.register;
						this.getTitle();
					} else {
						// Redirecting to Verify Code Form (UserExistInLoyalty)
						delete this.formModel.code;
						this.step = this.stepsMap.confirm;
						this.getTitle();
					}
					if (formModel.phone) {
						//this.customer.phone = formModel.phone;
					}
				}
			},
			(err: any) => {
				console.log('_onSignInByPhoneSubmit > Error: ', err);
				this.ui.loading = false;
				this.appService.alert({
					title: this.appService.translate('error_title'),
					content: this.appService.translate('error_general')
				});
			}
		);
	}

	//------------------------------------------------------------------------------------------------->
	// confirm phone
	//------------------------------------------------------------------------------------------------->

	resendPinCode() {
		this.ui.loading = true;
		return this.authService.resendPicode$({ phone: this.formModel.phone }).subscribe(
			(response: any) => {
				this.ui.loading = false;
			},
			(err: any) => {
				this.ui.loading = false;
				this.appService.alert({
					content: this.appService.translate('error_general')
				});
			},
		);
	}

	confirmPhone(form) {
		if (!form.valid) return;
		let formModel = this.formModel;
		this.ui.loading = true;
		return this.authService.signInByPhoneVerifyCode$(formModel).subscribe(
			(response: any) => {
				//this.ui.loading = false;
				this._setHeadersAndGetROSToken({ formModel, response });
			},
			(err: any) => {
				console.log('sign-in > _onSignInByPhoneVerifyCodeSubmit > signInByPhoneVerifyCode$ > Error:', err);
				this.ui.loading = false;
				this.appService.alert({
					title: this.appService.translate('error_title'),
					content: this.appService.translate('error_invalid_phone_verification_code')
				});
			}
		);
	}

	loginAnonymous() {
		this.dialogRef.close(
			{
				anonymous: true,
				phone: this.formModel.phone
			});
	}

	_setHeadersAndGetROSToken({ formModel, response }) {
		if (response && response.IsSuccess && response.ResponseData && response.ResponseData.accessToken && response.ResponseData.refreshToken) {

			// Storing the Loyalty Tokens and updating Headers for future requests
			this.authService.setHttpHeadersLoyaltyAccessToken(response.ResponseData.accessToken, response.ResponseData.refreshToken);

			// Getting the ROS Token
			return this.authService.getROSToken$(formModel).subscribe(
				(response: any) => {
					if (response && response.IsSuccess && response.ResponseData && response.ResponseData.Access_token && response.ResponseData.Refresh_token) {
						localStorage.setItem('refresh_token', response.ResponseData.Refresh_token);
						this.authService.setHttpHeadersAccessToken(response.ResponseData.Access_token, false, true);

						this.authService.getUserInfo(true).then(res => {
							this.ui.loading = false;
							this.onCloseSuccess();
						}).catch(err => {
							this.ui.loading = false;
							this.appService.alert({
								title: this.appService.translate('error_title'),
								content: this.appService.translate('error_general')
							});
						});
					}
				},
				(err: any) => {
					console.log('sign-in > _setHeadersAndGetROSToken > getROSToken$ > Error:', err);
					this.ui.loading = false;
					this.appService.alert({
						title: this.appService.translate('error_title'),
						content: this.appService.translate('error_general')
					});
				}
			);
		} else {
			console.log('sign-in > _onSignInByPhoneVerifyCodeSubmit > signInByPhoneVerifyCode$ > Next: Got response but without Loyalty tokens:', response);
			this.ui.loading = false;
			this.appService.alert({
				title: this.appService.translate('error_title'),
				content: this.appService.translate('error_general')
			});

		}
	}

	//------------------------------------------------------------------------------------------------->
	// signUp
	//------------------------------------------------------------------------------------------------->

	signUp(form) {
		if (!form.valid) return;
		this.ui.loading = true;
		let args = _.pick(this.formModel, ['FirstName', 'LastName', 'Email', 'phone']);
		return this.authService.insertCustomer$(args).subscribe(
			(response: any) => {
				this.appService.logTemplate("signUp", { request: args }, "sign up");
				this.ui.loading = false;
				if (response && response.IsSuccess) {
					// Redirecting to the verification code form
					this.step = this.stepsMap.confirm;
					this.getTitle();
				} else {
					this.appService.alert({
						title: this.appService.translate('error_title'),
						content: this.appService.translate('error_general')
					});
				}
			},
			(err: any) => {
				this.ui.loading = false;
				if (err.status == '409') {
					let message = this.appService.translate('error_general');
					switch (err.error?.Key) {
						case "emailExist":
							message = this.appService.translate('error_invalid_sign_in_email_already_exists');
							break;
					}

					this.appService.alert({
						title: this.appService.translate('error_title'),
						content: message
					});
				} else {
					this.appService.alert({
						title: this.appService.translate('error_title'),
						content: this.appService.translate('error_general')
					});
				}
			}
		);
	}

	//------------------------------------------------------------------------------------------------->
	// close success
	//------------------------------------------------------------------------------------------------->

	onCloseSuccess() {
		if (this.savePaymentInfo) {
			this.addPM();
		} else {
			this.ui.loading = false;
			this.dialogRef.close({});
			this.authService.signinChangedSource.next();
		}
	}

	addPM() {
		const ccinfo = this.appService.cachedPaymentInfo;
		this.entityService.addPaymentMethodToWallet(ccinfo)
			.then(response => {

			}).catch(() => {

			}).then(o => {
				this.ui.loading = false;
				this.dialogRef.close();
				this.authService.signinChangedSource.next();
			})
	}

}
